/**
 * @generated SignedSource<<ff9a2eb3ef0817a6cca08f228ec8f7ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation$variables = {
  announcementId: string;
  uploadToken: string;
};
export type CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation$data = {
  readonly addLinksToAnnouncement: {
    readonly addedLinks: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly announcementUpdated: {
      readonly id: string;
    };
  } | null;
};
export type CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation = {
  response: CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation$data;
  variables: CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "announcementId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uploadToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "announcementId",
            "variableName": "announcementId"
          },
          {
            "items": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "uploadToken",
                        "variableName": "uploadToken"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "attachment"
                  }
                ],
                "kind": "ObjectValue",
                "name": "links.0"
              }
            ],
            "kind": "ListValue",
            "name": "links"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AnnouncementsAddLinksMutationPayload",
    "kind": "LinkedField",
    "name": "addLinksToAnnouncement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Announcement",
        "kind": "LinkedField",
        "name": "announcementUpdated",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AnnouncementLink",
        "kind": "LinkedField",
        "name": "addedLinks",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a53f1ad5a1d1775e2f817362e1d22eab",
    "id": null,
    "metadata": {},
    "name": "CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation",
    "operationKind": "mutation",
    "text": "mutation CreateAnnouncementOverlay_addAttachmentToAnnouncement_Mutation(\n  $announcementId: ID!\n  $uploadToken: ID!\n) {\n  addLinksToAnnouncement(input: {announcementId: $announcementId, links: [{attachment: {uploadToken: $uploadToken}}]}) {\n    announcementUpdated {\n      id\n    }\n    addedLinks {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4a203bc02c11f78acc633f29b89d5e7";

export default node;
